import React, {useState,useEffect} from 'react';
import {Formulario, Input, Etiqueta, ContenedorBoton} from '../elementos/ElementosDeFormulario'
import Boton from '../elementos/Boton'
import Api from '../servicios/api';
import Alerta from '../elementos/Alerta'
import { useNavigate } from "react-router-dom";


const FormularioTipoPublicacion = ({tipopublicacion}) => {
    const [inputNombre, setInputNombre] = useState('');
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const navigate = useNavigate();

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        if(tipopublicacion){
            setInputNombre(tipopublicacion.TPub_Nombre);
        }
    }, [tipopublicacion]);

    const handleChange = (e) => {
        switch(e.target.name){
            case 'nombre':
                setInputNombre(e.target.value);
                break;
            default:
                break;
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setEstadoAlerta(false);
        setAlerta({});

        // Validaciones del lado del cliente para que los inputs no esten vacios
        if(inputNombre === ''){
            setEstadoAlerta(true);
            setAlerta({
                tipo: 'error',
                mensaje: 'Por favor rellena todos los datos'
            });
            return;
        }

        var datosEnviar;
        if(!tipopublicacion){
            datosEnviar = {nombre:inputNombre}
            
            fetch(Api+"?insertarTipoPublicacion",{
                method:"POST",
                body:JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                setInputNombre('');
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'exito',
                    mensaje: 'Tipo de publicación registrado correctamente.'
                });
            })
            .catch(console.log)
        }

        else{
            datosEnviar = {id:tipopublicacion.TPub_ID, nombre:inputNombre}

            fetch(Api+"?actualizarTipoPublicacion",{
                method:"POST",
                body:JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                navigate("/tipo-publicaciones");
            })
            .catch(console.log)
        }
    }

    return (
        <>
            <Formulario onSubmit={handleSubmit}>
                <div>
                    <Etiqueta htmlFor="">Nombre del Tipo de Publicación</Etiqueta>
                    <Input
                        type="text"
                        name="nombre"
                        placeholder="Ingrese Nombre"
                        value={inputNombre}
                        onChange={handleChange}
                    />
                </div>

                <ContenedorBoton>
                        <Boton to="/tipo-publicaciones">Cancelar</Boton>
                        <Boton as="button" type="submit" primario="true">
                            {tipopublicacion ? 'Actualizar' : 'Guardar'} 
                        </Boton>
                </ContenedorBoton>
            </Formulario>

            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setEstadoAlerta={setEstadoAlerta}
            />
        </>
    );
}
 
export default FormularioTipoPublicacion;